import jQuery from 'jquery'
import 'jquery-validation';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import CustomAnimation from "src/scripts/animation/customAnimation";
import {gsap} from "gsap";
import {COUNTRY_FIELDS, localizeCountry} from "src/scripts/utils/countries";

const customAnmation = new CustomAnimation();

// Backend endpoints — AmbilightZufriedenheitsgarantieStack Function URLs.
const UPLOAD_URL = 'https://mm2qk4kjyv2etuuzb7rlv7vxka0vlkwj.lambda-url.eu-central-1.on.aws/'; // erzeuge_url
const SUBMIT_URL = 'https://lwjhjygxzduemw53fktngwm33e0zadoh.lambda-url.eu-central-1.on.aws/'; // retoure_hochladen
const PREFILL_URL = 'https://6oi34agsbmeqxf6zaj5vnazlge0hseav.lambda-url.eu-central-1.on.aws/'; // daten_holen (GET ?rt=<token>)

// Prefilled fields whose input shows a localized rendering of the stored value.
const DISPLAY_ONLY_FIELDS = ['rueckgabefrist', 'purchasedate'];

class Returnpage {
  constructor() {
  }

  init() {
    this.initPrefill();
    this.initParallax();
    this.initForm();
  }

  // Read the non-guessable ?rt= token, remember it, and prefill any matching inputs
  // from the originating registration so the return is linked to the right customer.
  initPrefill = () => {
    this.returnToken = null;
    this.prefill = {};
    const rt = new URLSearchParams(window.location.search).get('rt');
    if (!rt) return;
    this.returnToken = rt;
    if (!PREFILL_URL) return;
    jQuery.ajax({
      type: 'GET',
      url: PREFILL_URL + '?rt=' + encodeURIComponent(rt),
      dataType: 'json',
    }).done((data) => {
      this.prefill = data || {};
      const isFrench = document.documentElement.lang === 'fr';
      // Baserow returns dates as ISO (yyyy-mm-dd); show them in the local format.
      const fmtDate = (v) => {
        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || '');
        if (!m) return v;
        return isFrench ? `${m[3]}/${m[2]}/${m[1]}` : `${m[3]}.${m[2]}.${m[1]}`;
      };
      const DATE_FIELDS = DISPLAY_ONLY_FIELDS;
      // Countries are stored as lowercase slugs -> show the label of this page's language.
      const display = (k, v) => {
        if (DATE_FIELDS.includes(k)) return fmtDate(v);
        if (COUNTRY_FIELDS.includes(k)) return localizeCountry(v, document.documentElement.lang);
        return v;
      };
      Object.entries(this.prefill).forEach(([k, v]) => {
        if (v == null) return;
        const el = jQuery('[name="' + k + '"]');
        if (el.length && !el.val()) el.val(display(k, v));
      });
      // Prominent "Rückgabefrist endet am" banner (#return_deadline).
      if (this.prefill.rueckgabefrist) {
        jQuery('#return_deadline').text(fmtDate(this.prefill.rueckgabefrist));
      }
    }).fail(() => { /* invalid/expired token → leave the form empty */ });
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);
    customAnmation.animateHeaderImage('.header');
    customAnmation.animateFromBottom('.form-group');
    customAnmation.animateButtonGroup('.button');
  }

  initForm = () => {
    this.resetForm();

    const isFrench = document.documentElement.lang === 'fr';

    // Custom-Validierung: Mindestens ein Kaufszenario ausgewählt
    jQuery.validator.addMethod(
      'atLeastOneScenario',
      function () {
        return (
          jQuery("#tv_purchase_scenario_replace_existing").is(":checked") ||
          jQuery("#tv_purchase_scenario_second_room").is(":checked") ||
          jQuery("#tv_purchase_scenario_first_tv").is(":checked") ||
          jQuery("#tv_purchase_scenario_other").is(":checked")
        );
      },
      // Fallback-Text (wird weiter unten sprachspezifisch überschrieben)
      'Bitte wählen Sie mindestens eine Option aus.'
    );

    // Custom-Validierung: Mindestens ein Kaufgrund ausgewählt
    jQuery.validator.addMethod(
      'atLeastOneReason',
      function () {
        return (
          jQuery("#purchase_reason_brand_trust").is(":checked") ||
          jQuery("#reason_previous_purchase").is(":checked") ||
          jQuery("#reason_reviews").is(":checked") ||
          jQuery("#reason_family_recommendation").is(":checked") ||
          jQuery("#reason_features").is(":checked") ||
          jQuery("#reason_ambilight").is(":checked") ||
          jQuery("#reason_price").is(":checked") ||
          jQuery("#reason_promotion").is(":checked")
        );
      },
      'Bitte wählen Sie mindestens eine Option aus.'
    );

    // Custom-Validierung: Mindestens eine Marke in Betracht gezogen
    jQuery.validator.addMethod(
      'atLeastOneBrand',
      function () {
        return (
          jQuery("#brand_considered_philips").is(":checked") ||
          jQuery("#brand_considered_samsung").is(":checked") ||
          jQuery("#brand_considered_lg").is(":checked") ||
          jQuery("#brand_considered_sony").is(":checked") ||
          jQuery("#brand_considered_tcl").is(":checked") ||
          jQuery("#brand_considered_panasonic").is(":checked") ||
          jQuery("#brand_considered_hisense").is(":checked") ||
          jQuery("#brand_considered_metz").is(":checked") ||
          jQuery("#brand_considered_grundig").is(":checked") ||
          jQuery("#brand_considered_other").is(":checked")
        );
      },
      'Bitte wählen Sie mindestens eine Option aus.'
    );

    //foto of tv
    document.getElementById('tv_accessory_photo').addEventListener('change', async function (event) {
      const fileInput = event.target;
      const label = document.querySelector('label[for="tv_accessory_photo"]');
      if (fileInput.files.length > 0) {
        fileInput.setAttribute('uploading', 'true');
        if (fileInput.files[0].size > 10 * 1024 * 1024) {
          label.textContent = isFrench
            ? 'Fichier trop volumineux (max. 10 Mo)'
            : 'Die Datei ist zu groß (max. 10 MB).';
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
          return;
        }
        label.textContent = isFrench ? 'Téléchargement en cours…' : 'Upload läuft …';
        try {
          /* eslint-disable-next-line no-inner-declarations */
          async function uploadToS3(presigned) {
            const form = new FormData();
            Object.entries(presigned.fields).forEach(([k, v]) => form.append(k, v));
            form.append("file", fileInput.files[0]); // <input type="file" id="fileInput">

            const res = await fetch(presigned.url, {
              method: "POST",
              contentType: null,
              body: form,
            });

            if (!res.ok) {
              const text = await res.text(); // S3-Fehlermeldung (XML) lesen
              throw new Error(`S3 upload failed: ${res.status} ${text}`);
            }
            // Erfolg = i.d.R. HTTP 204, ETag in Headern
            console.log("OK. Key:", presigned.fields.key);
            return presigned.fields.key;
          }
          jQuery.ajax({
            type: 'POST',
            url: UPLOAD_URL,
            contentType: "application/json; charset=utf-8",   // wir senden JSON
            dataType: "json",                                // wir erwarten JSON zurück
            data: JSON.stringify({
              filename: fileInput.files[0].name
            }),
          }).done(function (signedUrl) {
            uploadToS3(signedUrl).then((key) => {
              label.textContent = isFrench
                ? `${fileInput.files[0].name} a été téléchargé avec succès`
                : `${fileInput.files[0].name} wurde erfolgreich hochgeladen`;
              fileInput.removeAttribute('uploading');
              fileInput.setAttribute('key', key);

            }).catch(err => {
              console.log(err)
              label.textContent = (isFrench ? 'Le téléchargement a échoué : ' : 'Der Upload ist fehlgeschlagen: ') + err;
              fileInput.value = "";
              fileInput.removeAttribute('uploading');
            });

          }).catch(err => {
            console.log(err);
            label.textContent = (isFrench ? 'Le téléchargement a échoué : ' : 'Der Upload ist fehlgeschlagen: ') + err.responseText;
            fileInput.value = "";
            fileInput.removeAttribute('uploading');
          })

        } catch (err) {
          console.log(err)
          label.textContent = (isFrench ? 'Le téléchargement a échoué : ' : 'Der Upload ist fehlgeschlagen: ') + err;
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
        }

      } else {
        label.textContent = isFrench
          ? 'Photo du téléviseur Ambilight avec tous les accessoires, à télécharger.'
          : 'Foto des Ambilight Fernsehers inkl. Zubehör hochladen';
      }
    });

    const that = this;
    const formMessages = jQuery('#form-messages');

    const messagesDe = {
      // Kaufszenario-Gruppe
      tv_purchase_scenario_replace_existing: {
        atLeastOneScenario: 'Bitte wählen Sie mindestens eine der Optionen aus.'
      },
      purchase_scenario_other_text: 'Bitte geben Sie Ihre Option an, wenn Sie „Sonstiges“ gewählt haben.',

      // Kaufgründe-Gruppe
      purchase_reason_brand_trust: {
        atLeastOneReason: 'Bitte wählen Sie mindestens einen Kaufgrund aus.'
      },

      // Marken-Auswahl-Gruppe
      brand_considered_philips: {
        atLeastOneBrand: 'Bitte wählen Sie mindestens eine Marke aus.'
      },
      brand_considered_other_text: 'Bitte geben Sie eine Marke an, wenn Sie „Andere“ gewählt haben.',

      // Ambilight schon vorher gekannt (Radio-Gruppe)
      knew_ambilight_before_purchase: 'Bitte wählen Sie aus, ob Sie Ambilight vor dem Kauf kannten.',

      // Rückgabegrund (Textarea)
      ambilight_return_reason: 'Bitte geben Sie den Grund für Ihre Rückgabe an.',

      tv_accessory_photo: 'Bitte wählen Sie Ihr Foto aus.',

      participation: 'Bitte akzeptieren Sie die Teilnahmebedingungen und Datenschutzbestimmungen.',
      legalage: 'Bitte bestätigen Sie, dass Sie volljährig sind.',
      analysis: 'Bitte akzeptieren Sie die Bedingungen.'
    };

    const messagesFr = {
      // Kaufszenario-Gruppe
      tv_purchase_scenario_replace_existing: {
        atLeastOneScenario: 'Veuillez sélectionner au moins une des options.'
      },
      purchase_scenario_other_text: 'Veuillez préciser votre option si vous avez sélectionné « Autre ».',

      // Kaufgründe-Gruppe
      purchase_reason_brand_trust: {
        atLeastOneReason: 'Veuillez sélectionner au moins une raison d’achat.'
      },

      // Marken-Auswahl-Gruppe
      brand_considered_philips: {
        atLeastOneBrand: 'Veuillez sélectionner au moins une marque.'
      },
      brand_considered_other_text: 'Veuillez indiquer une marque si vous avez sélectionné « Autre ».',

      // Ambilight connu avant l’achat (groupe radio)
      knew_ambilight_before_purchase: 'Veuillez indiquer si vous connaissiez Ambilight avant l’achat.',

      // Motif de retour (textarea)
      ambilight_return_reason: 'Veuillez indiquer le motif de votre retour.',

      tv_accessory_photo: 'Veuillez sélectionner votre photo.',

      participation: 'Veuillez accepter les conditions de participation et la politique de confidentialité.',
      legalage: 'Veuillez confirmer que vous êtes majeur(e).',
      analysis: 'Veuillez accepter les conditions.'
    };

    jQuery("#return").validate({

      rules: {
        // mindestens ein Szenario
        tv_purchase_scenario_replace_existing: {
          atLeastOneScenario: true
        },

        // Textfeld nur required, wenn „Sonstiges“ angehakt ist
        purchase_scenario_other_text: {
          required: function () {
            return jQuery("#tv_purchase_scenario_other").is(":checked");
          }
        },

        // mindestens ein Kaufgrund
        purchase_reason_brand_trust: {
          atLeastOneReason: true
        },

        // mindestens eine Marke in Betracht gezogen
        brand_considered_philips: {
          atLeastOneBrand: true
        },

        // Textfeld nur required, wenn „Andere“ angehakt ist
        brand_considered_other_text: {
          required: function () {
            return jQuery("#brand_considered_other").is(":checked");
          }
        },

        // Radio-Group Ambilight bekannt?
        knew_ambilight_before_purchase: {
          required: true
        },

        // Rückgabegrund
        ambilight_return_reason: {
          required: true
        },

        tv_accessory_photo: 'required',

        participation: 'required',
        legalage: 'required'
      },
      messages: isFrench ? messagesFr : messagesDe,
      submitHandler(form) {
        const formData = jQuery(form).serializeArray().reduce((obj, item) => {
          obj[item.name] = item.value;
          return obj;
        }, {});

        formData['language'] = isFrench ? 'fr' : 'de';
        formData['lang'] = document.documentElement.lang;

        // link this return to the originating registration + carry prefilled identity
        if (that.returnToken) formData['return_token'] = that.returnToken;
        Object.entries(that.prefill || {}).forEach(([k, v]) => {
          if (v == null) return;
          // Date/country fields are displayed localized in the readonly prefill inputs;
          // send the stored (canonical) value back so Baserow keeps its own format.
          if (COUNTRY_FIELDS.includes(k) || DISPLAY_ONLY_FIELDS.includes(k)) formData[k] = v;
          else if (formData[k] == null || formData[k] === '') formData[k] = v;
        });

        if (jQuery('#tv_accessory_photo')[0].hasAttribute('uploading')) {
          formMessages.text(isFrench
            ? 'Veuillez patienter jusqu\'à ce que la photo soit téléchargée.'
            : 'Bitte warten Sie, bis das Foto hochgeladen wurde.');
          return
        } else if (jQuery('#tv_accessory_photo')[0].hasAttribute('key')) {
          formData['tv_accessory_photo'] = jQuery('#tv_accessory_photo').attr('key');
        }

        that.submitForm(formData, formMessages);
      }
    });

    // Live-Validierung beim Ändern einer der Szenario-Checkboxen
    jQuery(
      "#tv_purchase_scenario_replace_existing, " +
      "#tv_purchase_scenario_second_room, " +
      "#tv_purchase_scenario_first_tv, " +
      "#tv_purchase_scenario_other"
    ).on("change", function () {
      jQuery("#tv_purchase_scenario_replace_existing").valid();
      jQuery("#purchase_scenario_other_text").valid();
    });

    // Live-Validierung Kaufgründe-Checkboxen
    jQuery(
      "#purchase_reason_brand_trust, " +
      "#reason_previous_purchase, " +
      "#reason_reviews, " +
      "#reason_family_recommendation, " +
      "#reason_features, " +
      "#reason_ambilight, " +
      "#reason_price, " +
      "#reason_promotion"
    ).on("change", function () {
      jQuery("#purchase_reason_brand_trust").valid();
    });

    // Live-Validierung Marken-Checkboxen
    jQuery(
      "#brand_considered_philips, " +
      "#brand_considered_samsung, " +
      "#brand_considered_lg, " +
      "#brand_considered_sony, " +
      "#brand_considered_tcl, " +
      "#brand_considered_panasonic, " +
      "#brand_considered_hisense, " +
      "#brand_considered_metz, " +
      "#brand_considered_grundig, " +
      "#brand_considered_other"
    ).on("change", function () {
      jQuery("#brand_considered_philips").valid();
      jQuery("#brand_considered_other_text").valid();
    });

    // Live-Validierung Radio-Gruppe Ambilight bekannt?
    jQuery(
      "#knew_ambilight_before_purchase_yes, " +
      "#knew_ambilight_before_purchase_no"
    ).on("change", function () {
      jQuery("input[name='knew_ambilight_before_purchase']").valid();
    });

    // Live-Validierung Textarea Rückgabegrund
    jQuery("#ambilight_return_reason").on("keyup blur", function () {
      jQuery("#ambilight_return_reason").valid();
    });
  }

  submitForm(formData, formMessages) {
    const isFrench = document.documentElement.lang === 'fr';

    jQuery('.button_form_send').addClass('button_loading');
    jQuery.ajax({
      type: 'POST',
      url: SUBMIT_URL,
      data: JSON.stringify(formData),
      contentType: 'application/json',
      dataType: 'json',
      processData: false,
    })
      .done(function (response) {
        if(response){ // check whether response is received
          // Stash the identity/product fields so return_thankyou.html can build
          // the printable "Rückgabeformular" PDF (via sessionStorage, same origin).
          try {
            const pdfFields = ['return_token', 'vorgangsnummer', 'modelnumber', 'serialnumber',
              'firstname', 'lastname', 'street', 'street_number', 'postcode',
              'city', 'country', 'email', 'lang', 'purchasedate', 'rueckgabefrist',
              'retailer', 'retailer_street', 'retailer_street_number',
              'retailer_postcode', 'retailer_city', 'retailer_country'];
            const stash = {};
            pdfFields.forEach((k) => { if (formData[k] != null) stash[k] = formData[k]; });
            sessionStorage.setItem('ambilight_return_form', JSON.stringify(stash));
          } catch (e) { /* sessionStorage unavailable → PDF just renders blanks */ }
          window.location.href = "return_thankyou.html";
        }
        formMessages.text(response.message);
      })
      .fail(function (data) {
        formMessages.text(
          data.message ||
          (isFrench
            ? 'Une erreur s’est produite et votre message n’a pas pu être envoyé.'
            : 'Es ist ein Fehler aufgetreten und Ihre Nachricht konnte nicht gesendet werden.')
        );
      });
  }

  resetForm_dummy() {

    jQuery('#tv_accessory_photo').val('');

    jQuery('#participation').prop('checked', true);
    jQuery('#legalage').prop('checked', true);
    jQuery('#analysis').prop('checked', true);
  }

  resetForm() {

    jQuery('#tv_accessory_photo').val('');

    jQuery('#participation').prop('checked', false);
    jQuery('#legalage').prop('checked', false);
    jQuery('#analysis').prop('checked', false);
  }
}

export default Returnpage;
